export default "__VITE_ASSET__sdMFpc4I__"